import React, { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import HistoryOutlined from '@mui/icons-material/HistoryOutlined'
import { Link } from 'react-router-dom'

const SnapshotButton = ({ claim }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const available = claim.snapshotAvailable === true
  const icon = <HistoryOutlined fontSize="small" />
  const tooltipProps = {
    enterDelay: 500,
    leaveDelay: 50,
    open: tooltipOpen,
    onOpen: () => setTooltipOpen(true),
    onClose: () => setTooltipOpen(false),
  }

  if (available) {
    return (
      <Tooltip title="View snapshot" {...tooltipProps}>
        <IconButton
          aria-label="View snapshot"
          component={Link}
          onBlur={() => setTooltipOpen(false)}
          onFocus={() => setTooltipOpen(true)}
          size="small"
          sx={{ height: 36, width: 36 }}
          to={`/account/claimed/${claim.snapshotId}/snapshot`}
        >
          {icon}
        </IconButton>
      </Tooltip>
    )
  }

  return (
    <Tooltip title="View snapshot unavailable: No snapshot available for this claim." {...tooltipProps}>
      <span
        aria-label="View snapshot unavailable"
        onBlur={() => setTooltipOpen(false)}
        onFocus={() => setTooltipOpen(true)}
        role="group"
        tabIndex={0}
      >
        <IconButton aria-label="View snapshot" disabled size="small" sx={{ height: 36, width: 36 }}>
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default SnapshotButton
